import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import Lottie from 'lottie-react';
import animation from './e404.json';

function Error404() {
  return (
    <Card className="text-center">
      <Card.Body className="p-5">
        <Row>
          <Col md={4}>
            <Lottie animationData={animation} loop />
          </Col>
          <Col md={8}>
            <div className="display-1 text-300 fs-error">404</div>
            <p className="lead mt-4 text-800 font-sans-serif fw-semi-bold">
              Сторінка, яку ви шукаєте, не знайдена.
            </p>
            <hr />
            <p>
              Якщо ви думаєте, що це помилка, то
              <a href="mailto:support@ciat.net.ua" className="ms-1">
                повідомне нам
              </a>
              .
            </p>
            <Link className="btn btn-primary btn-sm mt-3" to="/">
              <FontAwesomeIcon icon={faHome} className="me-2" />
              Повернутися
            </Link>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default Error404;
